/**
  A simple component that just renders the `<table>` element with the correct
  theme classes.

  This component should only be needed when using `@renderTableElement={{false}}` to render
  the table element yourself. Please refer to the `@renderTableElement` documentation for
  more information.

  Example:

  ```hbs
  <YetiTable @data={{this.data}} @pagination={{true}} @renderTableElement={{false}} as |t|>

    <t.table> {{!-- we render the given table component ourselves --}}
      <t.header as |header|>
        ...
      </t.header>

      <t.body/>
    </t.table>

    <t.pagination/> {{!-- pagination controls outside the <table> element --}}

  </YetiTable>
  ```

  @class Table
*/ import { template as template_332ba7d4c81345db9a35dca8e2872c43 } from "@ember/template-compiler";
export default template_332ba7d4c81345db9a35dca8e2872c43(`
  <table class={{@theme.table}} ...attributes>
    {{yield}}
  </table>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9taWd1ZWwvd29ya3NwYWNlL2VtYmVyLXlldGktdGFibGUvZW1iZXIteWV0aS10YWJsZS9zcmMvY29tcG9uZW50cy95ZXRpLXRhYmxlL3RhYmxlLmdqcyJdLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAgQSBzaW1wbGUgY29tcG9uZW50IHRoYXQganVzdCByZW5kZXJzIHRoZSBgPHRhYmxlPmAgZWxlbWVudCB3aXRoIHRoZSBjb3JyZWN0XG4gIHRoZW1lIGNsYXNzZXMuXG5cbiAgVGhpcyBjb21wb25lbnQgc2hvdWxkIG9ubHkgYmUgbmVlZGVkIHdoZW4gdXNpbmcgYEByZW5kZXJUYWJsZUVsZW1lbnQ9e3tmYWxzZX19YCB0byByZW5kZXJcbiAgdGhlIHRhYmxlIGVsZW1lbnQgeW91cnNlbGYuIFBsZWFzZSByZWZlciB0byB0aGUgYEByZW5kZXJUYWJsZUVsZW1lbnRgIGRvY3VtZW50YXRpb24gZm9yXG4gIG1vcmUgaW5mb3JtYXRpb24uXG5cbiAgRXhhbXBsZTpcblxuICBgYGBoYnNcbiAgPFlldGlUYWJsZSBAZGF0YT17e3RoaXMuZGF0YX19IEBwYWdpbmF0aW9uPXt7dHJ1ZX19IEByZW5kZXJUYWJsZUVsZW1lbnQ9e3tmYWxzZX19IGFzIHx0fD5cblxuICAgIDx0LnRhYmxlPiB7eyEtLSB3ZSByZW5kZXIgdGhlIGdpdmVuIHRhYmxlIGNvbXBvbmVudCBvdXJzZWx2ZXMgLS19fVxuICAgICAgPHQuaGVhZGVyIGFzIHxoZWFkZXJ8PlxuICAgICAgICAuLi5cbiAgICAgIDwvdC5oZWFkZXI-XG5cbiAgICAgIDx0LmJvZHkvPlxuICAgIDwvdC50YWJsZT5cblxuICAgIDx0LnBhZ2luYXRpb24vPiB7eyEtLSBwYWdpbmF0aW9uIGNvbnRyb2xzIG91dHNpZGUgdGhlIDx0YWJsZT4gZWxlbWVudCAtLX19XG5cbiAgPC9ZZXRpVGFibGU-XG4gIGBgYFxuXG4gIEBjbGFzcyBUYWJsZVxuKi9cblxuPHRlbXBsYXRlPlxuICA8dGFibGUgY2xhc3M9e3tAdGhlbWUudGFibGV9fSAuLi5hdHRyaWJ1dGVzPlxuICAgIHt7eWllbGR9fVxuICA8L3RhYmxlPlxuPC90ZW1wbGF0ZT5cbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBMkJBO0FBRUEsZUFBQSwwQ0FBVSxDQUFBOzs7O0FBSVYsQ0FBQSxFQUFBO0lBQUE7UUFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7SUFBRDtBQUFBLEdBQUMifQ